import { LogOut, User } from "lucide-react";
import { useAuth } from "@/hooks/Auth";

export const FooterNavigation = () => {
  const { signOut } = useAuth();
  const userData = JSON.parse(
    localStorage.getItem("@MatriculaWeb:user") as any
  );

  return (
    <div className="pl-4 flex flex-col gap-5 mb-8 justify-end" style={{ minHeight: '20vh' }}>
      <div className="mt-4 flex gap-2 cursor-pointer">
        <div className="flex gap-2  text-white text-sm ">
          <User />
          <span className="">{userData?.usuario?.nome}</span>
        </div>
      </div>
      <button
        type="button"
        onClick={() => signOut()}
        className="text-red-800 flex gap-2 cursor-pointer items-center bg-transparent border-0 p-0 text-left"
      >
        <LogOut />
        <span>Sair</span>
      </button>
    </div>
  );
};
